import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>
              <span className="text-primary-500">99</span>
              <span className={isScrolled || !isHome ? "text-foreground-900" : "text-white"}>视频</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled || !isHome
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                <i className={`${cat.icon} mr-1`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`hidden md:flex items-center gap-1 px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              <i className="ri-information-line"></i>
              关于我们
            </Link>
            <button
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i
                className={`text-xl ${
                  isScrolled || !isHome ? "text-foreground-900" : "text-white"
                } ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}
              ></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-3 animate-[fadeIn_0.2s_ease]">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-4 py-3 text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <i className={`${cat.icon} text-lg w-6 h-6 flex items-center justify-center`}></i>
                <span className="text-sm">{cat.name}</span>
              </Link>
            ))}
            <div className="border-t border-background-200 mt-2 pt-2">
              <Link
                to="/about"
                className="flex items-center gap-3 px-4 py-3 text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <i className="ri-information-line text-lg w-6 h-6 flex items-center justify-center"></i>
                <span className="text-sm">关于我们</span>
              </Link>
            </div>
          </div>
        )}
      </nav>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </header>
  );
}